export default "__VITE_ASSET__Cr67o649__"